import 'react-toastify/dist/ReactToastify.css';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import Classdetails from './Class-details';
import React, { useEffect, useRef } from 'react';
import UserDetails from './UserPanel';
import axios from 'axios';
import { selectedGridRowsSelector } from '@mui/x-data-grid';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import { Container } from 'reactstrap';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Spinner,
} from 'reactstrap';
import { getoveralldata } from '../../store/classroom/actions';

//Import Breadcrumb

// Function to store selected items in sessionStorage
const saveToSessionStorage = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify([...value])); // Convert Set to array before storing
};
// // Function to load selected items from sessionStorage
const loadFromSessionStorage = (key) => {
  const savedData = sessionStorage.getItem(key);
  return savedData ? new Set(JSON.parse(savedData)) : new Set(); // Parse and convert back to Set
};

// Function to remove selected items from sessionStorage
const removeFromSessionStorage = (key) => {
  sessionStorage.removeItem(key);
};

const Transcription = () => {
  document.title = 'Linc Quality Hub';
  const [universityDropdownOpen, setUniversityDropdownOpen] = useState(false);
  const [timelineDropdownOpen, setTimelineDropdownOpen] = useState(false);
  const [termDropdownOpen, setTermDropdownOpen] = useState(false);
  const [programDropdownOpen, setProgramDropdownOpen] = useState(false);
  const [unitDropdownOpen, setUnitDropdownOpen] = useState(false);
  const [studentDropdownOpen, setstudentDropdownOpen] = useState(false);
  const [teacherDropdownOpen, setTeacherDropdownOpen] = useState(false);
  const [selectedUniversities, setSelectedUniversities] = useState(new Set());
  const [selectedTimelines, setSelectedTimelines] = useState(new Set());
  const [selectedPrograms, setSelectedPrograms] = useState(new Set());
  const [selectedUnits, setSelectedUnits] = useState(new Set());
  const [selectedstudents, setSelectedstudents] = useState(new Set());
  const [selectedTeachers, setSelectedTeachers] = useState(new Set());
  const [selectedTerms, setSelectedTerms] = useState(new Set()); // New state for selected terms

  const [appliedUniversities, setAppliedUniversities] = useState(new Set());
  const [appliedTimelines, setAppliedTimelines] = useState(new Set());
  const [appliedTerms, setAppliedTerms] = useState(new Set()); // New state for applied terms
  const [appliedUnit, setAppliedUnit] = useState(new Set()); // New state for applied terms
  const [appliedTeacher, setAppliedTeacher] = useState(new Set());
  const [appliedstudent, setAppliedstudent] = useState(new Set());
  const [appliedPrograms, setAppliedPrograms] = useState(new Set()); // New state for applied terms

  // State for fetched data
  const [universities, setUniversities] = useState([]);
  const [timelineYears, setTimelineYears] = useState([]);
  const [timelineTerms, setTimelineTerms] = useState([]); // To store timeline terms
  const [timelineUnit, setTimelineUnit] = useState([]); // To store timeline terms
  const [timelineTeacher, setTimelineTeacher] = useState([]);
  const [timelinestudent, setTimelinestudent] = useState([]);
  const [cardDataTranscription, setCardTranscription] = useState([]);
  const [programs, setPrograms] = useState([]);

  // // console.log("transcription", cardDataTranscription)
  const [universitySearch, setUniversitySearch] = useState('');
  const [programSearch, setProgramSearch] = useState('');
  const [timelineSearch, setTimelineSearch] = useState('');
  const [termSearch, setTermSearch] = useState('');
  const [unitSearch, setUnitSearch] = useState('');
  const [teacherSearch, setTeacherSearch] = useState('');
  const [studentSearch, setStudentSearch] = useState('');
  const [loadingFilter, setLoadingFilters] = useState(false);

  useEffect(() => {
    setLoading(true);
    setAppliedUniversities(loadFromSessionStorage('appliedUniversities'));
    setAppliedPrograms(loadFromSessionStorage('appliedPrograms'));
    setAppliedTimelines(loadFromSessionStorage('appliedTimelinetranscription'));
    setAppliedTerms(loadFromSessionStorage('appliedTermsutranscription'));
    setAppliedUnit(loadFromSessionStorage('appliedunittranscription'));
    setAppliedTeacher(loadFromSessionStorage('appliedteachertranscription'));
    setAppliedstudent(loadFromSessionStorage('appliedstudenttranscription'));

    // Handle teacherid directly if passed from another page

    setSelectedUniversities(loadFromSessionStorage('appliedUniversities'));
    setSelectedPrograms(loadFromSessionStorage('appliedPrograms'));

    setSelectedTimelines(
      loadFromSessionStorage('selectedTimelinestranscription'),
    );
    setSelectedTerms(loadFromSessionStorage('selectedTermstranscription'));

    setSelectedUnits(loadFromSessionStorage('selectedunittranscription'));
    setSelectedTeachers(loadFromSessionStorage('selectedteachertranscription'));
    setSelectedstudents(loadFromSessionStorage('selectedstudenttranscription'));

    setLoading(false);
  }, []);

  const handleSearchChange = (e, type) => {
    const value = e.target.value;
    switch (type) {
      case 'university':
        setUniversitySearch(value);
        break;
      case 'program':
        setProgramSearch(value);
        break;
      case 'timeline':
        setTimelineSearch(value);
        break;
      case 'term':
        setTermSearch(value);
        break;
      case 'unitSearch':
        setUnitSearch(value); // Set the unit search state when typed
        break;
      case 'teacher':
        setTeacherSearch(value); // Save search text for teachers
        break;
      case 'student':
        setStudentSearch(value); // Save search text for teachers
        break;
      default:
        break;
    }
  };
  const filterUniversities = (universitySearch) => {
    return universities.filter((u) =>
      u.university_name.toLowerCase().includes(universitySearch.toLowerCase()),
    );
  };

  const filterPrograms = (programSearch) => {
    return programs.filter(([id, name]) =>
      name.toLowerCase().includes(programSearch.toLowerCase()),
    );
  };

  const filterTimeline = (timelineSearch) => {
    return timelineYears.filter((year) => year.includes(timelineSearch));
  };

  const filterTerms = (termSearch) => {
    return timelineTerms.filter((term) =>
      term.toLowerCase().includes(termSearch.toLowerCase()),
    );
  };
  const filterUnits = (unitSearch) => {
    return timelineUnit.filter((unit) =>
      unit.name.toLowerCase().includes(unitSearch.toLowerCase()),
    );
  };

  const filterTeachers = () => {
    return Array.isArray(timelineTeacher)
      ? timelineTeacher.filter((teacher) =>
        teacher.full_name.toLowerCase().includes(teacherSearch.toLowerCase()),
      )
      : [];
  };

  const filterStudents = () => {
    return Array.isArray(timelinestudent)
      ? timelinestudent.filter((student) =>
        student.full_name.toLowerCase().includes(studentSearch.toLowerCase()),
      )
      : [];
  };

  const [loading1, setLoading] = useState(true); // New loading state
  const toggleUniversityDropdown = () => {
    setUniversityDropdownOpen((prev) => !prev);
  };

  const toggleTimelineDropdown = () => {
    setTimelineDropdownOpen((prev) => !prev);
  };

  const toggleProgramDropdown = () => {
    setProgramDropdownOpen((prev) => !prev);
  };

  const togglestudentDropdown = () => {
    setstudentDropdownOpen((prev) => !prev);
  };

  const toggleTermDropdown = () => {
    setTermDropdownOpen((prev) => !prev); // Toggle term dropdown
  };
  const toggleUnitDropdown = () => {
    setUnitDropdownOpen((prev) => !prev); // Toggle term dropdown
  };

  const toggleTeacherDropdown = () => {
    setTeacherDropdownOpen((prev) => !prev);
  };

  const handleSelectItem = (
    item,
    selectedSet,
    setSelectedSet,
    toggleDropdown,
  ) => {
    let newSelection = new Set(selectedSet);

    // If the item is part of universities or programs (which allow multiple selections), handle accordingly
    if (
      item.removename === 'removeuniversity' ||
      item.removename === 'removeprograms'
    ) {
      // If the selected item is already chosen, allow deselection
      if (selectedSet.has(item.id)) {
        newSelection.delete(item.id);
      } else {
        newSelection.add(item.id);
      }
    } else if (
      item.removename === 'removeyears' ||
      item.removename === 'removestudyperiod' ||
      item.removename === 'removeunits' ||
      item.removename === 'removeteacher' ||
      item.removename === 'removestudent'
    ) {
      // If the item is part of year or study period (single selection)
      newSelection.clear(); // Clear all previous selections
      // newSelection.delete(item.id);
      newSelection.add(item.id); // Add the new selection
    }

    // Clear dependent selections when an item is deselected
    if (item.removename === 'removeuniversity') {
      setSelectedPrograms(new Set());
      setSelectedTimelines(new Set());
      setSelectedTerms(new Set());
      setSelectedUnits(new Set());
      setSelectedTeachers(new Set());
      setTimelineTeacher([]);
      setPrograms([]);
      setTimelineYears([]);
      setTimelineTerms([]);
      setTimelineUnit([]);
      setSelectedstudents(new Set());
      setTimelinestudent([]);
    } else if (item.removename === 'removeprograms') {
      setSelectedTimelines(new Set());
      setSelectedTerms(new Set());
      setSelectedUnits(new Set());
      setSelectedTeachers(new Set());
      setTimelineTeacher([]);
      setTimelineYears([]);
      setTimelineTerms([]);
      setTimelineUnit([]);
      setSelectedstudents(new Set());
      setTimelinestudent([]);
    } else if (item.removename === 'removeyears') {
      setSelectedTerms(new Set());
      setTimelineTerms([]);
      setSelectedUnits(new Set());
      setSelectedTeachers(new Set());
      setTimelineTeacher([]);
      setTimelineUnit([]);
      setSelectedstudents(new Set());
      setTimelinestudent([]);
    } else if (item.removename === 'removestudyperiod') {
      setSelectedUnits(new Set());
      setTimelineUnit([]);
      setSelectedTeachers(new Set());
      setTimelineTeacher([]);
      setSelectedstudents(new Set());
      setTimelinestudent([]);
    } else if (item.removename === 'removeunits') {
      setSelectedTeachers(new Set());
      setTimelineTeacher([]);
      setSelectedstudents(new Set());
      setTimelinestudent([]);
    } else if (item.removename === 'removeteacher') {
      setSelectedstudents(new Set());
      setTimelinestudent([]);
    }

    setSelectedSet(newSelection);
    toggleDropdown();
  };
  const isItemSelected = (itemId, selectedSet) => selectedSet.has(itemId);

  const handleSelectItemTimeLine = (selectedYear) => {
    const newSelection = new Set(selectedTimelines);
    if (newSelection.has(selectedYear)) {
      newSelection.delete(selectedYear);
    } else {
      newSelection.add(selectedYear);
    }
    setSelectedTimelines(newSelection);
  };

  const handleSelectItemTerm = (selectedTerm) => {
    const newSelection = new Set(selectedTerms);
    if (newSelection.has(selectedTerm)) {
      newSelection.delete(selectedTerm);
    } else {
      newSelection.add(selectedTerm);
    }
    setSelectedTerms(newSelection);
  };

  const handleSelectItemunit = (selectedUnit) => {
    const newSelection = new Set(selectedUnits);
    if (newSelection.has(selectedUnit)) {
      newSelection.delete(selectedUnit);
    } else {
      newSelection.add(selectedUnit);
    }
    setSelectedUnits(newSelection);
  };
  const handleSelectTeacher = (selectedTeacher) => {
    const newSelection = new Set(selectedTeachers);
    if (newSelection.has(selectedTeacher)) {
      newSelection.delete(selectedTeacher);
    } else {
      newSelection.add(selectedTeacher);
    }
    setSelectedTeachers(newSelection);
  };

  const handleSelectstudent = (selectedstudent) => {
    const newSelection = new Set(selectedstudents);
    if (newSelection.has(selectedstudent)) {
      newSelection.delete(selectedstudent);
    } else {
      newSelection.add(selectedstudent);
    }
    setSelectedTeachers(newSelection);
  };
  const handleSelectItem1 = (item, selectedSet, setter, toggleDropdown) => {
    // Create a new selection set
    const newSelection = new Set();

    if (item.id !== 1) {
      // If it's not the "All" option
      newSelection.add(item.id); // Add only the selected student (ID)
    }

    setter(newSelection); // Update the state with the new selection
    toggleDropdown(); // Optionally toggle the dropdown visibility
  };

  const handleteacherSelectItem = (
    teacher,
    selectedTeachers,
    setSelectedTeachers,
    toggleTeacherDropdown,
  ) => {
    // Create a new Set that only contains the new selection
    const newSelectedteacher = new Set();
    newSelectedteacher.add(teacher.id); // Add the new unit's ID

    // Update state to reflect the new selected unit
    setSelectedTeachers(newSelectedteacher);
    toggleTeacherDropdown();
  };

  const handlestudentSelectItem = (
    student,
    selectedTeachers,
    setSelectedstudents,
    togglestudentDropdown,
  ) => {
    // Create a new Set that only contains the new selection
    const newSelectedstu = new Set();
    newSelectedstu.add(student.id); // Add the new unit's ID

    // Update state to reflect the new selected unit
    setSelectedstudents(newSelectedstu);
    togglestudentDropdown();
  };

  const isTimelineSelected = (selectedYear) =>
    selectedTimelines.has(selectedYear);
  const isTermSelected = (selectedTerm) => selectedTerms.has(selectedTerm);
  const isUnitSelected = (selectedUnit) => selectedUnits.has(selectedUnit);
  const isTeacherSelected = (selectedTeacher) =>
    selectedTeachers.has(selectedTeacher);
  const isStudentSelected = (selectedstudent) =>
    selectedstudents.has(selectedstudent);

  const handleApply = () => {
    // Check if both timelines and terms are selected
    // if (selectedTimelines.size > 0 && selectedTerms.size > 0) {
    //   toast.error("Please choose either a year or a term, not both.");
    //   return;
    // }

    if (selectedUniversities.size === 0) {
      toast.error('Please choose a university.');
      return;
    }
    if (selectedPrograms.size === 0) {
      toast.error('Please choose a program.');
      return;
    }

    if (selectedTimelines.size === 0) {
      toast.error('Please choose a year.');
      return;
    }
    if (selectedTerms.size === 0) {
      toast.error('Please choose a Term.');
      return;
    }

    if (selectedUnits.size === 0) {
      toast.error('Please choose a unit.');
      return;
    }

    if (selectedTeachers.size === 0) {
      toast.error('Please choose a fellow.');
      return;
    }

    if (selectedstudents.size === 0) {
      toast.error('Please choose a student.');
      return;
    }

    // // Check if both timelines and terms are selected
    // if (appliedTimelines.size > 0 && appliedTerms.size > 0) {
    //   toast.error("Please choose either a year or a term, not both.");
    //   return;
    // }

    // Apply selections
    setAppliedUniversities(new Set(selectedUniversities));
    setAppliedTimelines(new Set(selectedTimelines));
    setAppliedTerms(new Set(selectedTerms));
    setAppliedUnit(new Set(selectedUnits));
    setAppliedTeacher(new Set(selectedTeachers));
    setAppliedstudent(new Set(selectedstudents));
    setAppliedPrograms(new Set(selectedPrograms));

    // // console.log(selectedTeachers);

    saveToSessionStorage('appliedUniversities', selectedUniversities);
    saveToSessionStorage('appliedPrograms', selectedPrograms);
    saveToSessionStorage('appliedTimelinetranscription', selectedTimelines);
    saveToSessionStorage('appliedTermsutranscription', selectedTerms);
    saveToSessionStorage('appliedunittranscription', selectedUnits);
    saveToSessionStorage('appliedteachertranscription', selectedTeachers);
    saveToSessionStorage('appliedstudenttranscription', selectedstudents);

    saveToSessionStorage('selectedUniversities', selectedUniversities);
    saveToSessionStorage('selectedPrograms', selectedPrograms);
    saveToSessionStorage('selectedTimelinestranscription', selectedTimelines);
    saveToSessionStorage('selectedTermstranscription', selectedTerms);
    saveToSessionStorage('selectedunittranscription', selectedUnits);
    saveToSessionStorage('selectedteachertranscription', selectedTeachers);
    saveToSessionStorage('selectedstudenttranscription', selectedstudents);

    // Close all dropdowns
    setUniversityDropdownOpen(false);
    setTimelineDropdownOpen(false);
    setTermDropdownOpen(false);
    setUnitDropdownOpen(false);
    setTimelineTeacher(false);
    setTimelinestudent(false);
    setProgramDropdownOpen(false);
    fetchTeacher();
    fetchStudent();
  };

  // fetch filter
  const user_token = localStorage.getItem('usertoken');

  const fetchDataTabs = async () => {
    try {
      const payload = {
        mode: 'tabs',
        // user_id: parseInt(uid)
      };

      // console.log("Sending tabs request with token:", user_token);  // 🔍
      // console.log("Payload:", payload);

      const tabResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'personnel/',
        payload,
        {
          headers: {
            Authorization: `Token ${user_token}`,
          },
        },
      );
      localStorage.setItem('tabs', JSON.stringify(tabResponse.data));

      // console.log("Tabs Response:", tabResponse);
    } catch (error) {
      // console.log('Error fetching tab data:', error);
    }
  };

  useEffect(() => {
    fetchDataTabs();
  }, []);
  const fetchData = async () => {
    try {
      setLoadingFilters(true);
      const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      setUniversities(response.universities || []); // Ensure we set to an empty array if undefined
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoadingFilters(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (selectedUniversities && selectedUniversities.size > 0) {
      fetchDataPrograms();
    }
  }, [selectedUniversities]);
  const fetchDataPrograms = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        mode: 'metrics',
        sub_mode: 'program',
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      setPrograms(unitResponse.program || []);
      // setTimelineTerms(unitResponse.terms || []);
    } catch (error) {
      // console.log('Error fetching unit data:', error);
    }
  };
  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    // Call fetchData only if there are selected universities or timelines
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedPrograms.size > 0
    ) {
      fetchDataYear();
    }
  }, [selectedUniversities, selectedPrograms]);

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedTimelines.size > 0 &&
      selectedTerms.size > 0 &&
      selectedPrograms.size > 0
    ) {
      fetchDatawithYearUnit();
    }
  }, [
    selectedUniversities,
    selectedTimelines,
    selectedTerms,
    selectedPrograms,
  ]);

  const fetchDataYear = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        program:
          selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,

        mode: 'teacher_report',
        sub_mode: 'year',
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      setTimelineYears(unitResponse.year || []);
      // setTimelineTerms(unitResponse.terms || []);
    } catch (error) {
      // console.log('Error fetching unit data:', error);
    }
  };

  useEffect(() => {
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedPrograms.size > 0 &&
      selectedTimelines.size > 0
    ) {
      fetchDataTerm();
    }
  }, [selectedUniversities, selectedTimelines, selectedPrograms]);

  const fetchDataTerm = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        year: selectedTimelines.size > 0 ? Array.from(selectedTimelines) : null,
        program:
          selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,
        mode: 'teacher_report',
        sub_mode: 'term',
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      // setTimelineYears(unitResponse.year || []);
      setTimelineTerms(unitResponse.terms || []);
    } catch (error) {
      // console.log('Error fetching unit data:', error);
    }
  };

  const fetchDatawithYearUnit = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        program:
          selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,
        year: selectedTimelines.size > 0 ? Array.from(selectedTimelines) : null,
        term: selectedTerms.size > 0 ? Array.from(selectedTerms) : null,
        mode: 'teacher_report',
        sub_mode: 'unit',
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      setTimelineUnit(unitResponse.units || []);
    } catch (error) { }
  };

  useEffect(() => {
    if (
      (selectedUniversities && selectedUniversities.size > 0) ||
      selectedTimelines > 0 ||
      selectedTerms > 0 ||
      selectedUnits > 0 ||
      selectedTeachers > 0
    ) {
      fetchTeacher();
    }
  }, [selectedTimelines, selectedTerms, selectedUnits, selectedTeachers]);

  const fetchTeacher = async () => {
    if (
      (selectedUniversities && selectedUniversities.size > 0,
        selectedTimelines && selectedTimelines.size > 0,
        selectedTerms && selectedTerms.size > 0,
        selectedUnits && selectedUnits.size > 0)
    ) {
      try {
        const payload = {
          university:
            selectedUniversities.size > 0
              ? Array.from(selectedUniversities)
              : null,
          program:
            selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,
          year:
            selectedTimelines.size > 0 ? Array.from(selectedTimelines) : null,
          term: selectedTerms.size > 0 ? Array.from(selectedTerms) : null,
          unit_id: selectedUnits.size > 0 ? Array.from(selectedUnits) : null,
          mode: 'teacher_report',
          sub_mode: 'teacher',
        };
        const teacherResponse = await axios.post(
          process.env.REACT_APP_API_BASE_URL + 'filter/',
          payload,
          {
            headers: {
              Authorization: 'Token ' + user_token,
            },
          },
        );
        setTimelineTeacher(teacherResponse.teachers || []);
      } catch (error) { }
    }
  };

  useEffect(() => {
    if (
      (selectedUniversities && selectedUniversities.size > 0) ||
      selectedTimelines > 0 ||
      selectedTerms > 0 ||
      selectedUnits > 0 ||
      selectedTeachers > 0
    ) {
      fetchStudent();
    }
  }, [selectedTimelines, selectedTerms, selectedUnits, selectedTeachers]);

  const fetchStudent = async () => {
    if (
      (selectedUniversities && selectedUniversities.size > 0,
        selectedTimelines && selectedTimelines.size > 0,
        selectedTerms && selectedTerms.size > 0,
        selectedUnits && selectedUnits.size > 0,
        selectedTeachers && selectedTeachers.size > 0)
    ) {
      try {
        const payload = {
          university:
            selectedUniversities.size > 0
              ? Array.from(selectedUniversities)
              : null,
          program:
            selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,
          year:
            selectedTimelines.size > 0 ? Array.from(selectedTimelines) : null,
          term: selectedTerms.size > 0 ? Array.from(selectedTerms) : null,
          unit_id: selectedUnits.size > 0 ? Array.from(selectedUnits) : null,
          teacher_id:
            selectedTeachers.size > 0 ? Array.from(selectedTeachers) : null,
          mode: 'student_timeline',
          sub_mode: 'student',
        };
        const studentResponse = await axios.post(
          process.env.REACT_APP_API_BASE_URL + 'filter/',
          payload,
          {
            headers: {
              Authorization: 'Token ' + user_token,
            },
          },
        );
        setTimelinestudent(studentResponse.students || []);
      } catch (error) { }
    }
  };

  const resetData = () => {
    setCardTranscription([]);
  };
  useEffect(() => {
    if (
      (appliedUniversities && appliedUniversities.size > 0,
        appliedTimelines && appliedTimelines.size > 0,
        appliedTeacher && appliedTeacher.size > 0,
        appliedstudent && appliedstudent.size > 0)
    ) {
      const fetchDataTeacher = async () => {
        const payload = {
          university:
            appliedUniversities.size > 0
              ? Array.from(appliedUniversities)
              : null,
          program:
            selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,
          year: appliedTimelines.size > 0 ? Array.from(appliedTimelines) : null,
          term: appliedTerms.size > 0 ? Array.from(appliedTerms) : null,
          unit_ids: appliedUnit.size > 0 ? Array.from(appliedUnit) : null,
          teacher_ids:
            appliedTeacher.size > 0 ? Array.from(appliedTeacher) : null,
          student_id:
            appliedstudent.size > 0 ? Array.from(appliedstudent)[0] : null,
        };
        let config = {
          headers: {
            Authorization: `Token ${user_token}`,
          },
        };
        try {
          setLoading(true);

          const response = await axios.post(
            process.env.REACT_APP_API_BASE_URL + 'individual_student_timeline/',
            payload,
            config
          );
          setCardTranscription(response.data);

          if (response.status === 500) {
            resetData();
          }
        } catch (error) {
          console.error('Error fetching data:', error);
          resetData();
        } finally {
          setLoading(false); // Set loading to false after fetching
        }
      };

      fetchDataTeacher();
    }
  }, [
    appliedUniversities,
    appliedTimelines,
    appliedTerms,
    appliedUnit,
    appliedTeacher,
    appliedstudent,
  ]);

  const dispatch = useDispatch();

  const { conversationData, overallData, error, loading } = useSelector(
    (state) => ({
      overallData: state?.classroom?.OverallData?.overall_data || [],
      conversationData: state?.classroom?.OverallData?.conversation_data,
      error: state.classroom.error,
      loading: state.classroom.loading,
    }),
  );

  useEffect(() => {
    dispatch(getoveralldata());
  }, [dispatch]);

  // sticky filter bar
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY; // Current scroll position
      const threshold = 100; // Adjust this value as needed
      setIsSticky(scrollY > threshold);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const [slideIndex, setSlideIndex] = useState(0);
  const slideWidth = 300; // Adjust this based on your filter tag size

  const [showScrollButtons, setShowScrollButtons] = useState(false);

  const checkOverflow = () => {
    if (filterSummaryRef.current) {
      setShowScrollButtons(
        filterSummaryRef.current.scrollWidth >
        filterSummaryRef.current.clientWidth,
      );
    }
  };
  useEffect(() => {
    checkOverflow();
    window.addEventListener('resize', checkOverflow); // Recheck on window resize
    return () => window.removeEventListener('resize', checkOverflow);
  }, [
    selectedUniversities,
    selectedPrograms,
    selectedTimelines,
    selectedTerms,
  ]);

  // Function to handle the left scroll button click
  const handleLeftClick = () => {
    if (filterSummaryRef.current) {
      const newScrollLeft = Math.max(
        filterSummaryRef.current.scrollLeft - 200,
        0,
      );
      filterSummaryRef.current.scrollLeft = newScrollLeft;
    }
  };
  // Function to handle the right scroll button click
  const handleRightClick = () => {
    if (filterSummaryRef.current) {
      const maxScrollLeft =
        filterSummaryRef.current.scrollWidth -
        filterSummaryRef.current.clientWidth;
      const newScrollLeft = Math.min(
        filterSummaryRef.current.scrollLeft + 200,
        maxScrollLeft,
      );
      filterSummaryRef.current.scrollLeft = newScrollLeft;
    }
  };
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const filterSummaryRef = useRef(null);

  // Start dragging (onMouseDown)
  const startDrag = (e) => {
    const clientX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
    setIsDragging(true);
    setStartX(clientX);
    setScrollLeft(filterSummaryRef.current.scrollLeft);
    filterSummaryRef.current.style.cursor = 'grabbing'; // Change the cursor for desktop
    document.body.style.userSelect = 'none'; // Disable text selection globally
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
    const distance = clientX - startX;
    filterSummaryRef.current.scrollLeft = scrollLeft - distance;
  };

  const stopDrag = () => {
    setIsDragging(false);
    filterSummaryRef.current.style.cursor = 'grab';
    document.body.style.userSelect = ''; // Re-enable text selection globally
  };

  const removeUniversity = (universityId) => {
    setSelectedUniversities((prev) => {
      const newSet = new Set(prev);
      newSet.delete(universityId);
      return newSet;
    });
  };

  // Function to remove a program from the selected set
  // const removeProgram = (programId) => {
  //   setSelectedPrograms((prev) => {
  //     const newSet = new Set(prev);
  //     newSet.delete(programId);
  //     return newSet;
  //   });
  // };

  // Function to remove a timeline from the selected set
  const removeTimeline = (year) => {
    setSelectedTimelines((prev) => {
      const newSet = new Set(prev);
      newSet.delete(year);
      return newSet;
    });
  };

  // Function to remove a term from the selected set
  const removeTerm = (term) => {
    setSelectedTerms((prev) => {
      const newSet = new Set(prev);
      newSet.delete(term);
      return newSet;
    });
  };
  //fileter deleted selection
  const hasSelections =
    selectedUniversities.size > 0 ||
    selectedPrograms.size > 0 ||
    selectedTimelines.size > 0 ||
    selectedTerms.size > 0 ||
    selectedUnits.size > 0 ||
    selectedTeachers.size > 0 ||
    selectedstudents.size > 0;

  const clearAllSelections = () => {
    setSelectedUniversities(new Set());
    setSelectedPrograms(new Set());
    setSelectedTimelines(new Set());
    setSelectedTerms(new Set());
    setSelectedUnits(new Set());
    setSelectedTeachers(new Set());
    setSelectedstudents(new Set());
    setPrograms([]);
    setTimelineYears([]);
    setTimelineTerms([]);
    setTimelineUnit([]);
    setTimelineTeacher([]);
    setTimelinestudent([]);

    fetchData();

    removeFromSessionStorage('appliedUniversitiestranscription');
    removeFromSessionStorage('appliedProgramstranscription');
    removeFromSessionStorage('appliedTimelinetranscription');
    removeFromSessionStorage('appliedTermsutranscription');
    removeFromSessionStorage('appliedunittranscription');
    removeFromSessionStorage('appliedteachertranscription');
    removeFromSessionStorage('appliedstudenttranscription');
    removeFromSessionStorage('selectedUniversitiestranscription');
    removeFromSessionStorage('selectedProgramstranscription');
    removeFromSessionStorage('selectedTimelinestranscription');
    removeFromSessionStorage('selectedTermstranscription');
    removeFromSessionStorage('selectedunittranscription');
    removeFromSessionStorage('selectedteachertranscription');
    removeFromSessionStorage('selectedstudenttranscription');
    resetData();
  };

  return (
    <React.Fragment>
      <div className="page-content px-0">
        <Container fluid={true}>
          <div
            className={`idt top-filter mb-1 ${isSticky ? 'sticky-filter' : ''}`}
          >
            <div className=" ">
              <div className="idt d-flex mt-1 flex-md-row flex-column  justify-content-between  align-items-md-center align-items-end flex-wrap gap-2">
                <div className="d-flex flex-wrap gap-2 ">
                  {/* University Dropdown */}
                  <Dropdown
                    isOpen={universityDropdownOpen}
                    toggle={toggleUniversityDropdown}
                  >
                    <DropdownToggle
                      className={`btn uni-bg ${universityDropdownOpen ? '' : ' '
                        }`}
                      caret
                      style={{ color: '#656565' }}
                    >
                      {/* University <i className="mdi mdi-chevron-down" /> */}
                      {loadingFilter ? 'Loading' : 'University'}{' '}
                      <i className="mdi mdi=chevron-down" />
                    </DropdownToggle>
                    {!loadingFilter && (
                      <>
                        <DropdownMenu className="p-0">
                          {/* All Option */}
                          <input
                            type="text"
                            placeholder="Search Universities"
                            className="form-control"
                            value={universitySearch}
                            onChange={(e) =>
                              handleSearchChange(e, 'university')
                            }
                          />
                          {/* "Select All" Option */}
                          <DropdownItem
                            onClick={(e) => {
                              e.stopPropagation();
                              const allSelected =
                                selectedUniversities.size ===
                                universities.length;
                              const newSelection = new Set();

                              if (!allSelected) {
                                // Select all universities
                                universities.forEach((university) =>
                                  newSelection.add(university.id),
                                );
                                // Deselect all universities, applying the removeuniversity logic
                                setSelectedPrograms(new Set()); // Clear selected programs
                                setPrograms([]); // Reset program list
                                setSelectedTimelines(new Set());
                                setSelectedTerms(new Set());
                                setSelectedUnits(new Set());
                                setSelectedTeachers(new Set());
                                setTimelineUnit([]);
                                setTimelineTeacher([]);
                                setTimelineYears([]);
                                setTimelineTerms([]);
                                setSelectedstudents(new Set());
                                setTimelinestudent([]);
                              } else {
                                // Deselect all universities, applying the removeuniversity logic
                                setSelectedPrograms(new Set()); // Clear selected programs
                                setPrograms([]); // Reset program list
                                setSelectedTimelines(new Set());
                                setSelectedTerms(new Set());
                                setSelectedUnits(new Set());
                                setSelectedTeachers(new Set());
                                setTimelineUnit([]);
                                setTimelineTeacher([]);
                                setTimelineYears([]);
                                setTimelineTerms([]);
                                setSelectedstudents(new Set());
                                setTimelinestudent([]);
                              }

                              setSelectedUniversities(newSelection); // Update the selected universities set
                              toggleUniversityDropdown(); // Close the dropdown
                            }}
                          >
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={
                                  selectedUniversities.size ===
                                  universities.length
                                } // Check if all are selected
                                readOnly
                              />
                              <label className="form-check-label">All</label>
                            </div>
                          </DropdownItem>

                          {/* University Options */}
                          {/* {universities.map(university => ( */}
                          {filterUniversities(universitySearch).map(
                            (university) => (
                              <DropdownItem
                                key={university.id}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSelectItem(
                                    {
                                      id: university.id,
                                      name: university.university_name,
                                      removename: 'removeuniversity',
                                    },
                                    selectedUniversities,
                                    setSelectedUniversities,
                                    toggleUniversityDropdown,
                                  );
                                }}
                              >
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={isItemSelected(
                                      university.id,
                                      selectedUniversities,
                                    )}
                                    readOnly
                                  />
                                  <label className="form-check-label">
                                    {university.university_name}
                                  </label>
                                </div>
                              </DropdownItem>
                            ),
                          )}
                        </DropdownMenu>
                      </>
                    )}
                  </Dropdown>
                  <Dropdown
                    isOpen={programDropdownOpen}
                    toggle={toggleProgramDropdown}
                  >
                    <DropdownToggle
                      disabled={programs.length === 0}
                      className={`btn program-bg ${programs.length > 0 ? '' : 'disable'
                        }`}
                      caret
                      style={{ color: '#656565' }}
                    >
                      Programs <i className="mdi mdi-chevron-down" />
                    </DropdownToggle>
                    <DropdownMenu className="p-0">
                      <input
                        type="text"
                        placeholder="Search Programs"
                        className="form-control"
                        value={programSearch}
                        onChange={(e) => handleSearchChange(e, 'program')}
                      />
                      {/* {programs.map((program) => { */}
                      {/* const [programId, programName] = program;  // Destructure the array to get ID and name */}
                      {/* All Option */}
                      <DropdownItem
                        onClick={(e) => {
                          e.stopPropagation();
                          const allSelected =
                            selectedPrograms.size === programs.length;
                          const newSelection = new Set();
                          if (!allSelected) {
                            programs.forEach(([programId]) =>
                              newSelection.add(programId),
                            );
                            setSelectedTimelines(new Set());
                            setSelectedTerms(new Set());
                            setSelectedUnits(new Set());
                            setSelectedTeachers(new Set());
                            setTimelineUnit([]);
                            setTimelineTeacher([]);
                            setTimelineYears([]);
                            setTimelineTerms([]);
                            setSelectedstudents(new Set());
                            setTimelinestudent([]);
                          } else {
                            //deselect
                            setSelectedTimelines(new Set());
                            setSelectedTerms(new Set());
                            setSelectedUnits(new Set());
                            setSelectedTeachers(new Set());
                            setTimelineUnit([]);
                            setTimelineTeacher([]);
                            setTimelineYears([]);
                            setTimelineTerms([]);
                            setSelectedstudents(new Set());
                            setTimelinestudent([]);
                          }
                          setSelectedPrograms(newSelection);
                          toggleProgramDropdown();
                        }}
                      >
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={selectedPrograms.size === programs.length}
                            readOnly
                          />
                          <label className="form-check-label">All</label>
                        </div>
                      </DropdownItem>
                      {/* return ( */}
                      {filterPrograms(programSearch).map(
                        ([programId, programName]) => (
                          <DropdownItem
                            key={programId}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSelectItem(
                                {
                                  id: programId,
                                  name: programName,
                                  removename: 'removeprograms',
                                },
                                selectedPrograms,
                                setSelectedPrograms,
                                toggleProgramDropdown,
                              );
                            }}
                          >
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={isItemSelected(
                                  programId,
                                  selectedPrograms,
                                )}
                                readOnly
                              />
                              <label className="form-check-label">
                                {programName}
                              </label>
                            </div>
                          </DropdownItem>
                        ),
                      )}

                      {/* ); */}
                      {/* })} */}
                    </DropdownMenu>
                  </Dropdown>
                </div>

                <div className="d-flex  justify-content-end flex-wrap gap-2">
                  {/* Timeline Dropdown */}
                  <Dropdown
                    isOpen={timelineDropdownOpen}
                    toggle={toggleTimelineDropdown}
                  >
                    <DropdownToggle
                      disabled={timelineYears.length === 0}
                      className={`btn year-bg ${timelineYears.length > 0 ? '' : ' disable'
                        }`}
                      caret
                    >
                      Year <i className="mdi mdi-chevron-down" />
                    </DropdownToggle>
                    <DropdownMenu className="p-0">
                      <input
                        type="text"
                        placeholder="Search Year"
                        className="form-control"
                        value={timelineSearch}
                        onChange={(e) => handleSearchChange(e, 'timeline')}
                      />
                      {/* {timelineYears.map((year, index) => ( */}
                      {filterTimeline(timelineSearch).map((year, index) => (
                        <DropdownItem
                          key={index}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelectItem(
                              {
                                id: year,
                                name: year,
                                removename: 'removeyears',
                              },
                              selectedTimelines,
                              setSelectedTimelines,
                              toggleTimelineDropdown,
                            );
                          }}
                        >
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={isItemSelected(year, selectedTimelines)}
                              readOnly
                            />
                            <label className="form-check-label">{year}</label>
                          </div>
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </Dropdown>

                  {/* Timeline Term Dropdown */}
                  <Dropdown
                    isOpen={termDropdownOpen}
                    toggle={toggleTermDropdown}
                  >
                    <DropdownToggle
                      disabled={timelineTerms.length === 0}
                      className={`btn stu-period-bg ${timelineTerms.length > 0 ? '' : ' disable'
                        }`}
                      caret
                    >
                      Study Period <i className="mdi mdi-chevron-down" />
                    </DropdownToggle>
                    <DropdownMenu className="p-0">
                      <input
                        type="text"
                        placeholder="Search Study Period"
                        className="form-control"
                        value={termSearch}
                        onChange={(e) => handleSearchChange(e, 'term')}
                      />
                      {/* {timelineTerms.map((term, index) => ( */}
                      {filterTerms(termSearch).map((term, index) => (
                        <DropdownItem
                          key={index}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelectItem(
                              {
                                id: term,
                                name: term,
                                removename: 'removestudyperiod',
                              },
                              selectedTerms,
                              setSelectedTerms,
                              toggleTermDropdown,
                            );
                          }}
                        >
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={isTermSelected(term, selectedTerms)}
                              readOnly
                            />
                            <label className="form-check-label">{term}</label>
                          </div>
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </Dropdown>

                  <Dropdown
                    isOpen={unitDropdownOpen}
                    toggle={toggleUnitDropdown}
                  >
                    <DropdownToggle
                      disabled={timelineUnit.length === 0}
                      className={`btn units-bg ${timelineUnit.length > 0 ? '' : ' disable'
                        }`}
                      caret
                    >
                      Units <i className="mdi mdi-chevron-down" />
                    </DropdownToggle>
                    <DropdownMenu className="p-0">
                      <input
                        type="text"
                        placeholder="Search Units"
                        className="form-control"
                        value={unitSearch} // Bind the input value to the state variable
                        onChange={(e) => handleSearchChange(e, 'unitSearch')} // Pass 'unitSearch' type
                      />
                      {/* {timelineUnit.map(unit => ( */}
                      {filterUnits(unitSearch).map((unit) => (
                        <DropdownItem
                          key={unit.id}
                          onClick={(e) => {
                            e.stopPropagation();
                            // handleSelectItem({ id: unit.id, name: unit.name }, selectedUnits, setSelectedUnit, toggleUnitDropdown);
                            handleSelectItem(
                              {
                                id: unit.id,
                                name: unit.name,
                                removename: 'removeunits',
                              },
                              selectedUnits,
                              setSelectedUnits,
                              toggleUnitDropdown,
                            );
                          }}
                        >
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={isUnitSelected(unit.id, selectedUnits)}
                              readOnly
                            />
                            <label className="form-check-label">
                              {unit.name}
                            </label>
                          </div>
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </Dropdown>
                  <Dropdown
                    isOpen={teacherDropdownOpen}
                    toggle={toggleTeacherDropdown}
                  >
                    <DropdownToggle
                      disabled={timelineTeacher.length === 0}
                      className={`btn teachers-bg ${timelineTeacher.length > 0 ? '' : ' disable'
                        }`}
                      caret
                    >
                      Fellows <i className="mdi mdi-chevron-down" />
                    </DropdownToggle>
                    <DropdownMenu className="p-0">
                      <input
                        type="text"
                        placeholder="Search Teachers"
                        className="form-control"
                        value={teacherSearch}
                        onChange={(e) => handleSearchChange(e, 'teacher')}
                      />
                      {/* {Array.isArray(timelineTeacher) && timelineTeacher.map(teacher => (  // Safe check for array */}
                      {filterTeachers(teacherSearch).map((teacher) => (
                        <DropdownItem
                          key={teacher.id}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelectItem(
                              {
                                id: teacher.id,
                                name: teacher.full_name,
                                removename: 'removeteacher',
                              },
                              selectedTeachers,
                              setSelectedTeachers,
                              toggleTeacherDropdown,
                            );
                          }}
                        >
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={isTeacherSelected(
                                teacher.id,
                                selectedTeachers,
                              )}
                              readOnly
                            />
                            <label className="form-check-label">
                              {teacher.full_name}
                            </label>
                          </div>
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </Dropdown>

                  <Dropdown
                    isOpen={studentDropdownOpen}
                    toggle={togglestudentDropdown}
                  >
                    <DropdownToggle
                      disabled={timelinestudent.length === 0}
                      className={`btn mi-stone-bg ${timelinestudent.length > 0 ? '' : ' disable'
                        }`}
                      caret
                    >
                      Students <i className="mdi mdi-chevron-down" />
                    </DropdownToggle>
                    <DropdownMenu className="p-0">
                      <input
                        type="text"
                        placeholder="Search student"
                        className="form-control"
                        value={studentSearch}
                        onChange={(e) => handleSearchChange(e, 'student')}
                      />

                      {/* {Array.isArray(timelinestudent) && timelinestudent.map(student => ( */}
                      {filterStudents(studentSearch).map((student) => (
                        <DropdownItem
                          key={student.id}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelectItem(
                              {
                                id: student.id,
                                name: student.full_name,
                                removename: 'removestudent',
                              }, // Selected student item
                              selectedstudents, // Current selection state (Set)
                              setSelectedstudents, // Setter to update state
                              togglestudentDropdown, // Dropdown toggle function
                            );
                          }}
                        >
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={selectedstudents.has(student.id)} // Check if this student is selected
                              readOnly // Prevent user from manually toggling the checkbox
                            />
                            <label className="form-check-label">
                              {student.full_name}
                            </label>
                          </div>
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </Dropdown>

                  <button
                    type="button"
                    className="btn btn-primary border-0 py-1 px-3 me-1"
                    onClick={handleApply}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
            {/* normal nav filter show */}
            <div className="filters-show">
              <div className="selected-filters">
                {showScrollButtons && (
                  <button
                    className="slider-button slider-button-left"
                    onClick={handleLeftClick}
                  >
                    <i className="ri-arrow-left-s-line"></i>
                  </button>
                )}

                <div
                  className="filter-summary"
                  ref={filterSummaryRef}
                  onMouseDown={startDrag}
                  onMouseMove={handleMouseMove}
                  onMouseUp={stopDrag}
                  onMouseLeave={stopDrag}
                  onTouchStart={startDrag} // Touch equivalent of onMouseDown
                  onTouchMove={handleMouseMove} // Touch equivalent of onMouseMove
                  onTouchEnd={stopDrag} // Touch equivalent of onMouseUp
                >
                  {selectedUniversities.size > 0 && (
                    <div
                      className={`filter-item ${showScrollButtons ? 'ft-pl' : ''
                        }`}
                    >
                      {Array.from(selectedUniversities).map((universityId) => {
                        const university = universities.find(
                          (u) => u.id === universityId,
                        );
                        return university ? (
                          <p
                            key={universityId}
                            className="filter-tag university"
                          >
                            {university.university_name}{' '}
                            {/* <i
                              className="ri-close-line"
                              style={{ cursor: "pointer" }}
                              onClick={() => removeUniversity(universityId)}
                            ></i> */}
                          </p>
                        ) : null;
                      })}
                    </div>
                  )}

                  {selectedPrograms.size > 0 && (
                    <div className="filter-item">
                      {Array.from(selectedPrograms).map((programId) => {
                        const program = programs.find(
                          ([id]) => id === programId,
                        );
                        return program ? (
                          <p key={programId} className="filter-tag programs">
                            {program[1]}
                          </p>
                        ) : null;
                      })}
                    </div>
                  )}

                  {selectedTimelines.size > 0 && (
                    <div className="filter-item">
                      {Array.from(selectedTimelines).map((year, index) => (
                        <p key={index} className="filter-tag year">
                          {year}
                        </p>
                      ))}
                    </div>
                  )}

                  {selectedTerms.size > 0 && (
                    <div className="filter-item">
                      {Array.from(selectedTerms).map((term, index) => (
                        <p key={index} className="filter-tag stu-period">
                          {term}
                        </p>
                      ))}
                    </div>
                  )}

                  {/* Display selected units */}
                  {selectedUnits.size > 0 && (
                    <div className="filter-item">
                      {Array.from(selectedUnits).map((unitId) => {
                        const unit = timelineUnit.find((u) => u.id === unitId);
                        return unit ? (
                          <p key={unitId} className="filter-tag units">
                            {unit.name}
                          </p>
                        ) : null;
                      })}
                    </div>
                  )}

                  {selectedTeachers.size > 0 && (
                    <div className="filter-item">
                      {Array.from(selectedTeachers).map((teacherId) => {
                        // Check if timelineTeacher is an array before using find()
                        if (Array.isArray(timelineTeacher)) {
                          const teacher = timelineTeacher.find(
                            (t) => t.id === teacherId,
                          );
                          return teacher ? (
                            <p key={teacherId} className="filter-tag teachers">
                              {teacher.full_name}
                            </p>
                          ) : null;
                        } else {
                          console.error(
                            'timelineTeacher is not an array:',
                            timelineTeacher,
                          );
                          return null;
                        }
                      })}
                    </div>
                  )}

                  {selectedstudents.size > 0 && (
                    <div className="filter-item">
                      {Array.from(selectedstudents).map((studentId) => {
                        // Check if timelinestudent is an array before using find()
                        if (Array.isArray(timelinestudent)) {
                          const student = timelinestudent.find(
                            (s) => s.id === studentId,
                          );
                          return student ? (
                            <p key={studentId} className="filter-tag mi-stone">
                              {student.full_name}
                            </p>
                          ) : null;
                        } else {
                          console.error(
                            'timelinestudent is not an array:',
                            timelinestudent,
                          );
                          return null;
                        }
                      })}
                    </div>
                  )}
                </div>

                {showScrollButtons && (
                  <button
                    className="slider-button slider-button-right"
                    onClick={handleRightClick}
                  >
                    <i className="ri-arrow-right-s-line"></i>
                  </button>
                )}
              </div>
              <div className="">
                {hasSelections && (
                  <button
                    type="button"
                    className="clear-all-btn me-1"
                    onClick={clearAllSelections}
                  >
                    <i class="ri-close-fill"></i> Clear All
                  </button>
                )}
              </div>
            </div>
          </div>
          <div>
            <h3 className="bold">Transcription</h3>
          </div>

          {/* <UserDetails overallData={overallData} /> */}
          <UserDetails
            overallDataCards={cardDataTranscription}
            loading1={loading1}
          />

          <h5> {''}</h5>

          <Classdetails
            conversationData={conversationData}
            dataTabs={cardDataTranscription}
          />
        </Container>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </React.Fragment>
  );
};

export default Transcription;
